import { render, staticRenderFns } from "./sportsExpression.vue?vue&type=template&id=bf21c67a&scoped=true&"
import script from "./sportsExpression.vue?vue&type=script&lang=js&"
export * from "./sportsExpression.vue?vue&type=script&lang=js&"
import style0 from "./sportsExpression.vue?vue&type=style&index=0&id=bf21c67a&prod&lang=scss&"
import style1 from "./sportsExpression.vue?vue&type=style&index=1&id=bf21c67a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf21c67a",
  null
  
)

export default component.exports